'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  height: ', ';\n  position: absolute;\n  right: ', ';\n  width: ', ';\n\n  &::after {\n    padding: ', ';\n  }\n'], ['\n  height: ', ';\n  position: absolute;\n  right: ', ';\n  width: ', ';\n\n  &::after {\n    padding: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: inherit;\n  display: block;\n  flex-grow: 1;\n'], ['\n  color: inherit;\n  display: block;\n  flex-grow: 1;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  fill: currentColor;\n  stroke: currentColor;\n  stroke-width: 2;\n'], ['\n  fill: currentColor;\n  stroke: currentColor;\n  stroke-width: 2;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Translatable = require('../decorators/Translatable');

var _Translatable2 = _interopRequireDefault(_Translatable);

var _Style = require('../core/Style');

var _Memoize = require('../core/Memoize');

var _SafePureComponent2 = require('../core/SafePureComponent');

var _SafePureComponent3 = _interopRequireDefault(_SafePureComponent2);

var _sizes = require('HubStyleTokens/sizes');

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var TShirtSize = _interopRequireWildcard(_tshirtSize);

var _UIDialogButton = require('../dialog/UIDialogButton');

var _UIDialogButton2 = _interopRequireDefault(_UIDialogButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SIZE_OPTIONS = {
  small: {
    size: _sizes.SMALL_CLOSE_BUTTON_SIZE,
    padding: 12
  },
  medium: {
    size: _sizes.MEDIUM_CLOSE_BUTTON_SIZE,
    padding: 16
  },
  large: {
    size: _sizes.MODAL_CLOSE_BUTTON_SIZE,
    padding: 20
  },
  'extra-large': {
    size: _sizes.EXTRA_LARGE_CLOSE_BUTTON_SIZE,
    padding: 38
  }
};

var CloseButton = (0, _styledComponents2.default)(_UIDialogButton2.default).withConfig({
  displayName: 'UICloseButton__CloseButton'
})(_templateObject, function (props) {
  return (0, _Style.remCalc)(SIZE_OPTIONS[props.size]['size']);
}, (0, _Style.remCalc)(_sizes.MODAL_CLOSE_BUTTON_OFFSET), function (props) {
  return (0, _Style.remCalc)(SIZE_OPTIONS[props.size]['size']);
}, function (props) {
  return (0, _Style.remCalc)(SIZE_OPTIONS[props.size]['padding']);
});

var CloseIcon = _styledComponents2.default.svg.withConfig({
  displayName: 'UICloseButton__CloseIcon'
})(_templateObject2);

var CloseIconInner = _styledComponents2.default.path.withConfig({
  displayName: 'UICloseButton__CloseIconInner'
})(_templateObject3);

var renderedCloseIcon = _react2.default.createElement(
  CloseIcon,
  { viewBox: '0 0 14 14', xmlns: 'http://www.w3.org/2000/svg' },
  _react2.default.createElement(CloseIconInner, {
    d: 'M14.5,1.5l-13,13m0-13,13,13',
    transform: 'translate(-1 -1)'
  })
);

var renderCloseIcon = function renderCloseIcon() {
  return renderedCloseIcon;
};

var getStyle = function getStyle(color, style) {
  return _extends({ color: color }, style);
};

var UICloseButton = function (_SafePureComponent) {
  _inherits(UICloseButton, _SafePureComponent);

  function UICloseButton(props) {
    _classCallCheck(this, UICloseButton);

    var _this = _possibleConstructorReturn(this, (UICloseButton.__proto__ || Object.getPrototypeOf(UICloseButton)).call(this, props));

    _this._getStyle = (0, _Memoize.memoizeLastResult)(getStyle);
    return _this;
  }

  _createClass(UICloseButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          color = _props.color,
          disabled = _props.disabled,
          I18n = _props.I18n,
          onClick = _props.onClick,
          size = _props.size,
          style = _props.style,
          rest = _objectWithoutProperties(_props, ['className', 'color', 'disabled', 'I18n', 'onClick', 'size', 'style']);

      var computedSize = TShirtSize.fromProp(size).long;

      return _react2.default.createElement(CloseButton, _extends({}, rest, {
        'aria-label': I18n.text('salesUI.UICloseButton.label'),
        className: (0, _classNames2.default)('private-close__button', className, {
          'private-close__button--disabled': disabled
        }),
        'data-action': 'close',
        disabled: disabled,
        IconHolder: renderCloseIcon,
        onClick: onClick,
        size: computedSize,
        style: this._getStyle(color, style)
      }));
    }
  }]);

  return UICloseButton;
}(_SafePureComponent3.default);

UICloseButton.propTypes = {
  className: _react.PropTypes.string,
  color: _react.PropTypes.string,
  disabled: _react.PropTypes.bool.isRequired,
  I18n: _react.PropTypes.object,
  onClick: _react.PropTypes.func.isRequired,
  size: TShirtSize.propTypeForSizes(['sm', 'md', 'lg', 'xl']),
  style: _react.PropTypes.object
};

UICloseButton.defaultProps = {
  disabled: false,
  size: 'large'
};

exports.default = (0, _Translatable2.default)(UICloseButton);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/button/UICloseButton.js
// module id = 242
// module chunks = 2 3